export const CLEAR_MESSAGE = 'Messaging/CLEAR_MESSAGE';
export const CLEAR_MESSAGE_ERROR = 'Messaging/CLEAR_MESSAGE_ERROR';
export const EMPTY_MESSAGING = 'Messaging/EMPTY_MESSAGING';

export const FETCH_CONVERSATIONS = 'Messaging/FETCH_CONVERSATIONS';
export const FETCH_CONVERSATIONS_SUCCESS = 'Messaging/FETCH_CONVERSATIONS_SUCCESS';
export const FETCH_CONVERSATIONS_FAILURE = 'Messaging/FETCH_CONVERSATIONS_FAILURE';

export const FETCH_MESSAGES = 'Messaging/FETCH_MESSAGES';
export const FETCH_MESSAGES_SUCCESS = 'Messaging/FETCH_MESSAGES_SUCCESS';
export const FETCH_MESSAGES_FAILURE = 'Messaging/FETCH_MESSAGES_FAILURE';

export const MARK_CONVERSATION_READ = 'Messaging/MARK_CONVERSATION_READ';
export const MARK_CONVERSATION_READ_SUCCESS = 'Messaging/MARK_CONVERSATION_READ_SUCCESS';
export const MARK_CONVERSATION_READ_FAILURE = 'Messaging/MARK_CONVERSATION_READ_FAILURE';

export const SEND_MESSAGE = 'Messaging/SEND_MESSAGE';
export const SEND_MESSAGE_SUCCESS = 'Messaging/SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAILURE = 'Messaging/SEND_MESSAGE_FAILURE';

export const SET_CONVERSATION = 'Messaging/SET_CONVERSATION';
export const SET_MESSAGE = 'Messaging/SET_MESSAGE';
export const SET_SUBJECT = 'Messaging/SET_SUBJECT';



// WEBPACK FOOTER //
// ./src/containers/Messaging/store/constants.js